module.exports = __webpack_public_path__ + "img/grace-la-margna_0.836d51de.jpg";